import axios from 'axios'
import {Notify} from 'vant';
import Vue from 'vue'
import router from "@/router";

new Vue({
    router,
})

export function fetch(options) {
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            headers: {
                'Content-Type': 'application/json',
            }
        });
        instance(options)
            .then(response => {
                if (response.data.code == 200) {
                    if (response.data.status == "SUCCESS") { //只过滤返回服务器端状态为200的数据
                        resolve(response.data);
                    } else if (response.data.status == 'UNLOGIN') {

                    } else if (response.data.status == 'FAIL') {
                        Notify(response.data.message);
                    } else {
                        Notify(response.data.message);
                    }
                } else {
                    Notify('服务器异常');
                }
            })
            .catch(err => {
                Notify(err);
                reject(err);
            })
    });
}
